import { Col, useTheme } from "@commonlibs";
import clsx from "clsx";
import SimpleList from "../../util/SimpleList/SimpleList";
import { ListProps } from "./List.types";
import { ListRoot } from "./List.styles";

export default function List<T>({
    label = "",
    className,
    style,
    gap = 0,
    labelGap: labelGapProp,
    LabelProps,
    ...rest
}: ListProps<T>): JSX.Element {
    const { spacing } = useTheme();
    const labelGap = typeof labelGapProp === "number" ? spacing[labelGapProp] : undefined;

    return (
        <ListRoot gap={labelGap} className={clsx("list", className)} style={style} label={label} {...LabelProps}>
            <Col className="list-wrapper" flex={1} gap={spacing[gap]} css={{ width: "100%" }}>
                <SimpleList {...rest} />
            </Col>
        </ListRoot>
    );
}
